import React, { useState, ReactNode } from "react";
import { PageTitleContext } from "./PageTitleContextTypes";

interface PageTitleProviderProps {
  children: ReactNode;
}

export const PageTitleProvider: React.FC<PageTitleProviderProps> = ({
  children,
}) => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");

  const setPageTitle = (newTitle: string, newSubtitle?: string) => {
    setTitle(newTitle);
    setSubtitle(newSubtitle || "");
  };

  const clearPageTitle = () => {
    setTitle("");
    setSubtitle("");
  };

  return (
    <PageTitleContext.Provider
      value={{
        title,
        subtitle,
        setPageTitle,
        clearPageTitle,
      }}
    >
      {children}
    </PageTitleContext.Provider>
  );
};
